import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, Cell } from "recharts";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

const cardBase =
  "rounded-xl p-5 flex flex-col gap-3 border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] hover:shadow-[0_0_20px_#00ff9044] transition-shadow";

const AttendanceOverview = ({ managerId }) => {
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(`${API_BASE}/api/manager/attendance/summary?manager_id=${managerId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => { if (!res.ok) throw new Error("Failed to load attendance"); return res.json(); })
      .then((data) => setSummary(data.summary || []))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [managerId]);

  const totals = summary.reduce(
    (acc, s) => ({
      present: acc.present + (s.present_days || 0),
      late: acc.late + (s.late_days || 0),
      absent: acc.absent + (s.absent_days || 0),
    }),
    { present: 0, late: 0, absent: 0 }
  );

  const chartData = summary.map((s) => ({
    name: s.name?.split(" ")[0] || "?",
    Present: s.present_days || 0,
    Late: s.late_days || 0,
    Absent: s.absent_days || 0,
  }));

  return (
    <div className={cardBase}>
      <div className="flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest">Team Attendance</span>
        <span className="text-2xl">📅</span>
      </div>

      {loading && <p className="text-white/20 text-sm animate-pulse">Loading...</p>}
      {error && <p className="text-red-400 text-sm">⚠ {error}</p>}

      {!loading && !error && (
        <>
          {summary.length > 0 && (
            <div className="flex gap-2 flex-wrap">
              <span className="text-xs px-3 py-1 rounded-full bg-[#00ff90]/10 text-[#00ff90] border border-[#00ff90]/20">
                ✓ {totals.present} Present
              </span>
              <span className="text-xs px-3 py-1 rounded-full bg-yellow-500/10 text-yellow-400 border border-yellow-500/20">
                ⏱ {totals.late} Late
              </span>
              <span className="text-xs px-3 py-1 rounded-full bg-red-500/10 text-red-400 border border-red-500/20">
                ✗ {totals.absent} Absent
              </span>
            </div>
          )}

          {chartData.length > 0 ? (
            <ResponsiveContainer width="100%" height={130}>
              <BarChart data={chartData} margin={{ top: 0, right: 0, left: -28, bottom: 0 }}>
                <XAxis dataKey="name" tick={{ fontSize: 10, fill: "rgba(255,255,255,0.25)" }} />
                <YAxis tick={{ fontSize: 10, fill: "rgba(255,255,255,0.25)" }} allowDecimals={false} />
                <Tooltip contentStyle={{ background: "#0d0d0d", border: "1px solid #00ff9033", borderRadius: 8, fontSize: 11 }} labelStyle={{ color: "#00ff90" }} />
                <Legend wrapperStyle={{ fontSize: 11, color: "rgba(255,255,255,0.35)", paddingTop: 4 }} />
                <Bar dataKey="Present" stackId="a" fill="#00ff90" fillOpacity={0.8} />
                <Bar dataKey="Late" stackId="a" fill="#fbbf24" fillOpacity={0.8} />
                <Bar dataKey="Absent" stackId="a" fill="#f87171" fillOpacity={0.8} radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <p className="text-white/20 text-sm">No records found.</p>
          )}
        </>
      )}
    </div>
  );
};

export default AttendanceOverview;